import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import {RedButton, BlueButton, GreenButton} from './MyButton';
import TextareaAutosize from 'react-textarea-autosize';
import s from './CreateCard.module.css';
import noImagePng from'../asset/no-image.png';
import {Form} from 'react-bootstrap';

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default function CreateCard(prop) {	
	const navigate = useNavigate();
	
	//let tmpString = "<S>\nSeeding\n<Q>\nWhat is it?\n<A>\nIt is a bus.\n<H>\n<E>\n<S>\nBudding\n<Q>\nCan you see a car?\n<A>\nYes.\n<H>\n<E>\n<S>\nBlossom\n<Q>\nWhat is the man doing?\n<A>\nHe is waiting for a bus.\n<H>\n<E>\n<S>\nExplorer\n<Q>\n<A>\nThe driver was shocked when the silly boy ran across the road without looking out for traffic.\n<H>\nshocked\nlook out/looking out\ntraffic\n<E>"
	let tmpString = "<S>\nSeeding\n<T>\nTransport\n<Q>\nWhat is it?\n<A>\nIt is a bus.\n<H>\nshocked\nlook out/looking out\ntraffic\n<E>"
	
	const [sentence, setSentence] = useState(tmpString);
	const [name, setName] = useState("");
	
	const [createCardObjs, setCreateCardObjs] = useState([]);
	
	const [clickIndex, setClickIndex] = useState(0);
	
	const proceedCards = async () => {
		const result = sentence.split(/\r?\n/);
		let objs = [];
		let obj = {};
		let cTask = null;
		setClickIndex(0);
		for(let i=0; i<result.length; i++) {
			if (result[i].trim() == '') {
				continue;
			}
			switch (result[i]) {
				case '<S>':
					cTask = result[i].trim();
					obj = {I:null,L:"",Q:"",T:[],A:[],H:[]};
					break;
				case '<Q>':
				case '<A>':
				case '<H>':
				case '<T>':
					cTask = result[i].trim();
					break;
				case '<E>':
					objs.push(obj);
					obj = {};
					break;
				default:
					switch(cTask) {
						case '<S>':
							obj.L = result[i].trim();
							break;
						case '<Q>':
							obj.Q = result[i].trim();
							break;
						case '<T>':
							obj.T.push(result[i].trim());
							break;
						case '<A>':
							obj.A.push(result[i].trim());
							break;
						case '<H>':
							obj.H.push(result[i].trim());
							break;
					}
			}
		}
		
		setCreateCardObjs(objs);		
	}
	
	const [confirmming, setConfirmming] = useState(false);
	const confirmCards = async () => {
		if (!confirmming) {
			setConfirmming(true);
			
			let canConfirm = true;
			for(let i = 0; i<createCardObjs.length; i++) {
				if (!imgObjs[i]) {
					console.log(i);
					canConfirm = false;
					break;
				}
			}
			
			if (canConfirm) {
				
				for(let i = 0; i<createCardObjs.length; i++) {
					try {
						const data = new FormData();
						data.append("level", createCardObjs[i].L);
						data.append("question", createCardObjs[i].Q);
						
						createCardObjs[i].H.forEach(h => data.append('hints[]', h));
						createCardObjs[i].A.forEach(a => data.append('answers[]', a));
						createCardObjs[i].T.forEach(t => data.append('themes[]', t));
						data.append("imagefile", imgObjs[i]);
						
						await postFormData("cardApi/createNewCard", data, navigate).then(res => {
							setSuccessIndexIds((p)=>[...p, i])
						});		
					} catch (err) {
						console.log(err);
					}
				}
			}
			
		}
		
		
	}
	
	// specify upload params and API url to file upload
	const getUploadParams = ({ meta, file }) => {
		return { url: '<FILE_UPLOAD_API_URL>' }
	}
	 
	// handle the status of the file upload
	const handleChangeStatus = ({ meta, file }, status) => {
		console.log(status, meta, file)
	}

	const [tmpImage, setTmpImage] = useState();

	const [imgObjs, setImgObjs] = useState([]);

	const [successIndexIds, setSuccessIndexIds] = useState([]);

	const reStart = () => {
		setCreateCardObjs([]);
		setSuccessIndexIds([]);
		setConfirmming(false);
		
	}

	return (<div onPaste={e=>{
		
				let isImg = false;
				var items = (e.clipboardData || e.originalEvent.clipboardData).items;							
				
				for (let i in items) {
					var item = items[i];
						
						if (item.kind === 'file') {
							
							if (clickIndex < createCardObjs.length) {
								var blob = item.getAsFile();				

								let tmp = createCardObjs[clickIndex];
								tmp.blob = blob;
								setImgObjs({...imgObjs, [clickIndex]:blob});
								tmp.I = URL.createObjectURL(blob);
								createCardObjs[clickIndex] = tmp;
								setCreateCardObjs([...createCardObjs]);	
								setClickIndex((p)=>(p+1));
							}
							isImg = true;
						}
					
				}
				if (isImg) {
					e.preventDefault();
				}
			}}>

	
		<h1>Quick Create Card</h1>
		
		{
			(createCardObjs.length === 0) && (<>
				<textarea className={s.textAreaAuto} value={sentence} rows={10} wrap='off' onChange={(e) => {
					setSentence(e.target.value);
				}}/>
				<div></div>
				<div className="general-red-btn general-red-btn-default" onClick={() => proceedCards()}>Proceed?</div>
			</>)
		}
		{
			(createCardObjs.length > 0) && (<div><div className={s.cardsHolder}>{
				createCardObjs.map((c, indexC) =>{
					console.log(c.L);
					return (<div key={indexC} className={(indexC == clickIndex) ? s.cardHolderClick : s.cardHolder} onClick={()=>setClickIndex(indexC)}>
					
							{(successIndexIds.includes(indexC)) && (<div className={s.successOverlay}><div className={s.successOverlayText}>SUCCESS!</div></div>)}
							
							{<div className={s.cardImgHolder}><img className={s.cardImg} src={(c.I) ? c.I :noImagePng}  alt="icon"/></div>}
							<div className={s.cardDetailHolder}>
								<div className={s.levelSelectionHolder}>
									<Form.Select value={c.L} onChange={(e)=>{
											createCardObjs[indexC].L = e.target.value;
											setCreateCardObjs([...createCardObjs]);
										}}>
										<option value="Seeding">Seeding</option>
										<option value="Budding">Budding</option>
										<option value="Blossom">Blossom</option>
										<option value="Explorer">Explorer</option>
										<option value="Voyager">Voyager</option>
										<option value="Navigator">Navigator</option>
										<option value="Trailblazer">Trailblazer</option>
									</Form.Select>
								</div>
								<div className={s.inputBoxHolder}>									
									<p className={s.cardLabel}>Q</p>
									<textarea className={s.textAreaSmall} value={c.Q} rows={1} wrap='on' onChange={(e) => {
											let tmp = createCardObjs[indexC];
											tmp.Q = e.target.value;
											createCardObjs[indexC] = tmp;
											setCreateCardObjs([...createCardObjs]);
									}}/>
								</div>
								<div className={s.inputBoxHolder}>
									<p className={s.cardLabel}>T</p>
									<div className={s.cardInputHolder}>
										{
											c.T.map((t, indexT)=>{
												
												return (<textarea key={'t' + indexC + '-' + indexT} className={s.textAreaSmall} value={t} rows={1} wrap='on' onChange={(e) => {
															let tmp = createCardObjs[indexC].T[indexT];
															tmp = e.target.value;
															createCardObjs[indexC].T[indexT] = tmp;
															setCreateCardObjs([...createCardObjs]);
												}}/>)
												
											})
										}
									</div>
								</div>
								<div className={s.inputBoxHolder}>
									<p className={s.cardLabel}>A</p>
									<div className={s.cardInputHolder}>
										{
											c.A.map((a, indexA)=>{
												
												return (<textarea key={'a' + indexC + '-' + indexA} className={s.textAreaSmall} value={a} rows={
														(['Seeding', 'Budding', 'Blossom'].indexOf(c.L) > -1) ? 1 : 5
													} wrap='on' onChange={(e) => {
															let tmp = createCardObjs[indexC].A[indexA];
															tmp = e.target.value;
															createCardObjs[indexC].A[indexA] = tmp;
															setCreateCardObjs([...createCardObjs]);
												}}/>)
												
											})
										}
									</div>
								</div>
								<div className={s.inputBoxHolder}>
									<p className={s.cardLabel}>H</p>
									<div className={s.cardInputHolder}>
										{
											c.H.map((h, indexH)=>{
												
												return (<textarea key={'h' + indexC + '-' + indexH} className={s.textAreaSmall} value={h} rows={1} wrap='on' onChange={(e) => {
															let tmp = createCardObjs[indexC].H[indexH];
															tmp = e.target.value;
															createCardObjs[indexC].H[indexH] = tmp;
															setCreateCardObjs([...createCardObjs]);
												}}/>)
												
											})
										}
									
									</div>
								</div>
							</div>
						</div>
					);
				}
			)
			}
			
			
			</div>
			{(successIndexIds.length !== createCardObjs.length) && (<RedButton isEnabled = {!confirmming} clickedAction={confirmCards}  bText="Confirm?" />)}
			{(successIndexIds.length === createCardObjs.length) && (<RedButton isEnabled={true} clickedAction={()=>reStart()}  bText="Reset" />)}
			</div>
			
			)
		}
		
	</div>)
}